import type { ChecklistItemDto } from './schemas/notes.js';

/**
 * Conversions texte <-> liste, utilisées pour « Afficher / Masquer les cases à cocher ».
 * Une ligne de texte = un élément ; les lignes vides sont ignorées.
 */
export function textToChecklist(
  content: string,
): Array<Pick<ChecklistItemDto, 'text' | 'checked'>> {
  return content
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((text) => ({ text, checked: false }));
}

export function checklistToText(items: ReadonlyArray<Pick<ChecklistItemDto, 'text'>>): string {
  return items
    .map((item) => item.text)
    .filter((text) => text.trim().length > 0)
    .join('\n');
}

/** Une note est « vide » si elle n'a aucun contenu exploitable : Keep ne la crée pas. */
export function isNoteEmpty(note: {
  title: string;
  content: string;
  items: ReadonlyArray<Pick<ChecklistItemDto, 'text'>>;
  attachmentCount?: number;
}): boolean {
  return (
    note.title.trim() === '' &&
    note.content.trim() === '' &&
    note.items.every((item) => item.text.trim() === '') &&
    (note.attachmentCount ?? 0) === 0
  );
}
